import { Drawer, Select } from 'antd';
import styled from 'styled-components';

export const StyledDrawer = styled(Drawer)`
  .ant-drawer-extra {
    display: flex;
    align-self: baseline;
    padding: 10px 0;
  }
`;

export const StyledSelect = styled(Select)`
  width: fit-content;
  margin: 2px 0 0 -8px;
  box-shadow: none !important;
  box-sizing: none !important;

  .ant-select-selector {
    border: none !important;

    .ant-select-selection-item {
      font-size: 18;
    }
  }
`;

export const ContentWrapper = styled.div`
  display: flex;
  flex-direction: row;
  height: 100%;

  .ant-menu-light.ant-menu-root.ant-menu-vertical {
    border-inline-end: none;
    border: none;
  }
`;

export const RightPanel = styled.div`
  flex: 1;
  height: 100%;
  overflow-y: auto;
  margin-left: 10px;
`;

export const EditMetricWrapper = styled.div`
  position: sticky;
  top: 0;
  padding: 15px 0 10px;
  background: white;
  z-index: 1000;
`;
